<template>
  <div>
    <b-spinner
      v-if="isLoading"
      class="align-middle"
    />
    <div v-else>
      <h2
        class="mb-2"
      >
        {{ reportName }}
      </h2>
      <b-row>
        <b-col
          cols="3"
        >
          <b-card>
            <!-- <ReportDetailsModelItem
              v-for="(item,index) in reportViewFields"
              :key="index"
              :item="item"
            /> -->
            <div>
              <h5 class="d-flex justify-content-between my-2">
                <span>Column Selection</span>
                <!-- Dropdown -->
                <b-dropdown
                  variant="link"
                  toggle-class="mx-auto p-0"
                  no-caret
                  :right="$store.state.appConfig.isRTL"
                >

                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="align-middle text-body"
                    />
                  </template>
                  <b-dropdown-item
                    @click="selectAll"
                  >
                    <span>Select All</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="deselectAll"
                  >
                    <span>Deselect All</span>
                  </b-dropdown-item>
                </b-dropdown>
              </h5>

              <v-select
                v-model="selectedFields"
                multiple
                class="mb-2"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="reportViewFields"
                placeholder="Select"
                :clearable="false"
                :close-on-select="false"
              >
                <template
                  #selected-option-container="{ option }"
                >
                  <div
                    style="display: none"
                  >{{ option }}</div>
                </template>
              </v-select>

              <draggable
                v-model="selectedFields"
              >
                <b-badge
                  v-for="(field, index) in selectedFields"
                  :key="index"
                  v-b-tooltip.hover.right="field"
                  tag="div"
                  class="d-flex justify-content-between position-relative mb-1 pr-2 text-left text-wrap badge-selected-column"
                  variant="primary"
                >
                  <div class="d-flex align-items-bottom">
                    <img src="@/assets/images/icons/more-vertical.svg">
                    <span class="text-break">{{ field.label | cutString }}</span>
                  </div>
                  <feather-icon
                    icon="XIcon"
                    size="18"
                    class="close-icon cursor-pointer"
                    @click="removeFieldFromSelected(index)"
                  />
                </b-badge>
              </draggable>
            </div>

            <div>
              <h5>Group By</h5>
              <v-select
                v-model="groupBy"
                class="mb-2"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="fieldsOptions"
                :reduce="field => field.value"
                label="text"
                placeholder="Select"
              >
                <template #selected-option="option">
                  <div class="text-break">
                    <strong>{{ option.text }}</strong>
                  </div>
                </template>
              </v-select>
            </div>

            <b-button
              variant="primary"
              class="w-100"
              :disabled="reportViewFields.length === 0"
              @click="resetAllTableData"
            >
              Update Table
            </b-button>
          </b-card>
        </b-col>
        <b-col
          cols="9"
        >
          <!-- Table Container Card -->
          <b-card
            no-body
          >

            <div class="table-header m-2">
              <h4 class="mb-2 d-flex align-items-center justify-content-between">
                <span>
                  <span v-if="!reportView">Select Report Type</span>
                  <span v-else>{{ reportView.name }}</span>
                  <feather-icon
                    icon="EditIcon"
                    size="18"
                    class="ml-1 cursor-pointer"
                    @click="openReportViewModal"
                  />
                </span>
                <b-button
                  variant="primary"
                  @click="showFilterModal"
                >
                  Add Filter
                </b-button>
              </h4>
              <!-- Table Top -->
              <b-row>
                <b-col
                  cols="12"
                  class="mb-2"
                >
                  <p v-if="filters.children > 0">
                    Selected filters
                  </p>
                  <b-badge
                    v-for="(filter, index) in filters.children"
                    :key="index"
                    class="p-1 mr-1 text-primary"
                    variant="light"
                  >
                    <span v-if="filter.type == 'query-builder-rule'">{{ filter.query.rule }}</span>
                    <span v-if="filter.type == 'query-builder-group'">
                      Filter group:
                      <span
                        v-for="(filterRow, indexRow) in filter.query.children"
                        :key="indexRow"
                      >
                        {{ filterRow.query.rule }}
                      </span>
                    </span>
                    <feather-icon
                      icon="Trash2Icon"
                      size="18"
                      class="ml-1 cursor-pointer"
                      @click="removeFilterFromTable(index)"
                    />
                  </b-badge>
                </b-col>
                <!-- Per Page -->
                <b-col
                  v-if="showPerPage"
                  cols="12"
                  class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                >
                  <label class="mr-1 mb-0">Show</label>
                  <v-select
                    v-model="perPage"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="perPageOptions"
                    :clearable="false"
                    class="per-page-selector d-inline-block ml-50 mr-1"
                  />
                  <b-form-checkbox
                    v-model="reportView.with_program_filter"
                    class="ml-1 bulk-checkbox"
                    :disabled="true"
                  >
                    Filtered By Program
                  </b-form-checkbox>
                  <b-form-checkbox
                    v-model="allElementsChecked"
                    class="ml-1 bulk-checkbox"
                    @change="selectAllOnTheReport"
                  >
                    Select All on the Report
                  </b-form-checkbox>

                  <b-form-checkbox
                    v-model="selectedAllOnThePage"
                    :disabled="allElementsChecked"
                    class="ml-1 bulk-checkbox"
                    @change="markElementsOnPage"
                  >
                    Select All on the Page
                  </b-form-checkbox>
                </b-col>

                <!-- Search -->
                <b-col
                  cols="12"
                >
                  <div class="d-flex align-items-center justify-content-end">
                    <div
                      v-if="groupedData.length > 0"
                      class="mr-3"
                    >
                      <b-button
                        class="mr-1"
                        variant="outline-primary"
                        @click="collapseAll"
                      >
                        Collapse All
                      </b-button>
                      <b-button
                        variant="outline-primary"
                        @click="expandAll"
                      >
                        Expand All
                      </b-button>
                    </div>
                  </div>
                </b-col>
              </b-row>

              <report-details-manage-buttons
                :report-id="reportId"
                :all-elements-checked="allElementsChecked"
                :marked-elements="markedElements"
                :report-view="reportView"
                :total-items="totalItems"
                @openSaveReportModal="openSaveReportModal"
                @exportReport="exportReport"
              />
            </div>

            <b-table
              v-if="!isLoading"
              v-show="groupedData.length == 0"
              ref="reportTable"
              responsive
              :items="fetchTableList"
              :busy.sync="isBusy"
              primary-key="id"
              class="position-relative"
            >
              <template #table-busy>
                <div class="my-2">
                  <b-spinner class="align-middle" />
                </div>
              </template>

              <template #head()="data">
                <div
                  v-if="data.column !== 'selected'"
                  class="cursor-pointer"
                  :style="{
                    fontWeight: data.column === sortBy ? '600' : '400',
                  }"
                  @click="sortByColumn(data.column)"
                >
                  {{ data.label | fixTableHeaderView }}
                </div>

                <div
                  v-else
                  :style="{ fontWeight: 400 }"
                >
                  {{ data.label }}
                </div>
              </template>

              <template #cell(selected)="data">
                <b-form-checkbox
                  v-model="markedElements"
                  :value="data.item"
                  inline
                />
              </template>

              <template
                v-for="(slot, index) in tableColumns"
                v-slot:[`cell(${slot})`]="data"
              >
                <span :key="index">
                  <img
                    v-if="checkIfSlotValueIsBase64File(data.item[slot])"
                    class="image-slot"
                    :src="data.item[slot]"
                  >
                  <span v-else> {{ data.item[slot] }} </span>
                </span>
              </template>
            </b-table>

            <template
              v-if="groupedData"
            >
              <div
                ref="groupedTablesContainer"
                class="grouped-tables-container"
              >
                <b-table-simple
                  v-for="(data, index) in groupedData"
                  :key="index"
                  class="mb-3"
                  :style="{ width: getContainerWith() }"
                >
                  <thead
                    :ref="'groupedTableHeader' + index"
                    head-variant="light"
                  >
                    <b-tr>
                      <template
                        v-for="(column, i) in tableColumns"
                      >
                        <b-th
                          v-if="column !== 'selected' && column !== 'uuid'"
                          :key="i"
                        >
                          <span
                            v-if="index == 0"
                            class="w-100 cursor-pointer"
                            :style="{
                              fontWeight: column === sortBy ? '600' : '400',
                            }"
                            @click="sortForGroupedData(column)"
                          >{{ column | fixTableHeaderView }}</span>
                          <span
                            v-else
                            style="fontWeight: 400"
                          >{{ column | fixTableHeaderView }}</span>
                        </b-th>
                        <b-th
                          v-else-if="column == 'selected'"
                          :key="i"
                        >
                          <b-form-checkbox
                            v-model="data.selectAll"
                            class="mr-1 bulk-checkbox"
                            @change="markElementsOnGroup(index, data.selectAll)"
                          />
                        </b-th>
                      </template>
                    </b-tr>
                  </thead>
                  <b-tbody>
                    <template v-for="(subitem, iSub) in data.grouped">
                      <b-tr
                        v-show="iSub === 0 || !data.collapsed"
                        :key="iSub"
                      >
                        <b-td
                          v-if="iSub === 0"
                          :rowspan="data._total"
                          class="align-top bg-light"
                        >
                          <div
                            class="stiky-rowspan"
                            :style="{
                              top: getHeaderHeight('groupedTableHeader' + index)
                            }"
                          >
                            <div class="stiky-rowspan__value">
                              <span v-if="data.group_by.value">
                                {{ data.group_by.value }}
                              </span>
                              <span v-else> Null </span>
                            </div>
                            <div class="stiky-rowspan__total">
                              Subtotal: {{ data._total }}
                            </div>
                            <div
                              class="cursor-pointer stiky-rowspan__collapse"
                              @click="toggleGroupedTableCollapse(index)"
                            >
                              <feather-icon
                                v-if="data.collapsed"
                                icon="ChevronDownIcon"
                                size="16"
                                class="align-middle text-body"
                              />
                              <feather-icon
                                v-else
                                icon="ChevronUpIcon"
                                size="16"
                                class="align-middle text-body"
                              />
                            </div>
                          </div>
                        </b-td>
                        <template
                          v-for="(value, name, idx) in subitem"
                        >
                          <b-td
                            v-if="name !== 'selected' && name !== 'uuid' && name !== groupByOptions.name"
                            :key="idx"
                          >{{ value }}</b-td>
                          <b-td
                            v-else-if="name == 'selected'"
                            :key="idx"
                          >
                            <b-form-checkbox
                              v-model="markedElements"
                              :value="subitem"
                              inline
                            />
                          </b-td>
                        </template>
                      </b-tr>
                    </template>
                  </b-tbody>
                </b-table-simple>
              </div>
            </template>

            <div class="mx-2 mb-2">
              <b-row>

                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                  <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
                </b-col>
                <!-- Pagination -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
                >

                  <b-pagination
                    v-if="totalItems && perPage !== 'all'"
                    v-model="currentPage"
                    :total-rows="totalItems"
                    :per-page="perPage"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                  >
                    <template #prev-text>
                      <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                      />
                    </template>
                    <template #next-text>
                      <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                      />
                    </template>
                  </b-pagination>

                </b-col>

              </b-row>

              <b-row
                class="my-2"
              >
                <b-col
                  v-if="showPerPage"
                  cols="12"
                  class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                >
                  <label class="mr-1 mb-0">Show</label>
                  <v-select
                    v-model="perPage"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="perPageOptions"
                    :clearable="false"
                    class="per-page-selector d-inline-block ml-50 mr-1"
                  />
                  <b-form-checkbox
                    v-model="reportView.with_program_filter"
                    class="ml-1 bulk-checkbox"
                    :disabled="true"
                  >
                    Filtered By Program
                  </b-form-checkbox>
                  <b-form-checkbox
                    v-model="allElementsChecked"
                    class="ml-1 bulk-checkbox"
                    @change="selectAllOnTheReport"
                  >
                    Select All on the Report
                  </b-form-checkbox>

                  <b-form-checkbox
                    v-model="selectedAllOnThePage"
                    :disabled="allElementsChecked"
                    class="ml-1 bulk-checkbox"
                    @change="markElementsOnPage"
                  >
                    Select All on the Page
                  </b-form-checkbox>
                </b-col>
              </b-row>

              <report-details-manage-buttons
                :report-id="reportId"
                :all-elements-checked="allElementsChecked"
                :marked-elements="markedElements"
                :report-view="reportView"
                :total-items="totalItems"
                @openSaveReportModal="openSaveReportModal"
                @exportReport="exportReport"
              />
            </div>

            <div
              v-if="validationErrors.length"
              class="form-group pt-1"
            >
              <p
                v-for="(validationError, index) in validationErrors"
                :key="index"
                class="text-center text-danger"
              >
                {{ validationError }}
              </p>
            </div>

          </b-card>
        </b-col>
      </b-row>

      <ReportViewListModal
        @setReportView="setReportView"
      />
      <!-- Filters modal -->
      <FiltersModal
        :filters-data="filters"
        :fields-options="fieldsOptions"
        @saveFilters="saveFilters"
      />

      <SaveReportModal
        :report-name="reportName"
        :report-type="saveReportType"
        @saveReport="saveReport"
      />

      <bulk-communicate-modal
        v-if="reportView && selectedFields && markedElements.length"
        :marked-elements="markedElements"
        :fields-options="executeRequestData.fields_options"
        :execute-data="executeRequestData"
        :all-elements-checked="allElementsChecked"
        :total-elements-count="totalItems"
        :with-execute="true"
        @successfullySend="bulkCommunicateSuccess"
      />

      <bulk-add-to-group-modal
        v-if="reportView && selectedFields && markedElements.length"
        :marked-elements="markedElements"
        :fields-options="executeRequestData.fields_options"
        :execute-data="executeRequestData"
        :all-elements-checked="allElementsChecked"
        :with-execute="true"
        :program-id="programId"
        @successfullySend="bulkAddToGroupSuccess"
      />

      <bulk-adding-charge-modal
        v-if="reportView && selectedFields && markedElements.length"
        :marked-elements="markedElements"
        :fields-options="executeRequestData.fields_options"
        :execute-data="executeRequestData"
        :all-elements-checked="allElementsChecked"
        :total-elements-count="totalItems"
        :with-execute="true"
        :filter-name="'application_id'"
        :program-id="programId"
        @success="bulkCreateChargeSuccess"
      />

      <bulk-generate-letter-modal
        v-if="reportView && selectedFields && markedElements.length"
        :marked-elements="markedElements"
        :fields-options="executeRequestData.fields_options"
        :execute-data="executeRequestData"
        :all-elements-checked="allElementsChecked"
        :total-elements-count="totalItems"
        :with-execute="true"
        :filter-name="'application_id'"
        :program-id="programId"
        @success="bulkGenerateLetterSuccess"
      />
    </div>

    <bulk-tag-assign-modal
      v-if="reportView && selectedFields && markedElements.length"
      :marked-elements="markedElements"
      :fields-options="executeRequestData.fields_options"
      :execute-data="executeRequestData"
      :all-elements-checked="allElementsChecked"
      :total-elements-count="totalItems"
      :with-execute="true"
      :filter-name="'application_id'"
      :program-id="programId"
      @success="bulkTagAssignSuccess"
    />

    <bulk-change-applications-status
      v-if="reportView && selectedFields && markedElements.length"
      :marked-elements="markedElements"
      :fields-options="executeRequestData.fields_options"
      :execute-data="executeRequestData"
      :all-elements-checked="allElementsChecked"
      :total-elements-count="totalItems"
      :with-execute="true"
      :filter-name="'application_id'"
      :program-id="programId"
      @success="bulkChangeApplicationsStatusSuccess"
    />
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BTable, BPagination, BButton, VBModal, BBadge, BSpinner, BFormCheckbox,
  BTableSimple, BTbody, BTr, BTh, BTd, VBTooltip, BDropdown, BDropdownItem,
} from 'bootstrap-vue'

import { v4 as uuidv4 } from 'uuid'
import draggable from 'vuedraggable'
import { downloadExportFile } from '@core/mixins/downloadExportFile'

import vSelect from 'vue-select'
import store from '@/store'
import useReportDetails from '@/views/admin/reports-v2/reports/report-details/useReportDetails'
import ReportViewListModal from '@/views/admin/reports-v2/reports/report-details/report-view-list-modal/ReportViewListModal.vue'
import FiltersModal from '@/views/admin/reports-v2/reports/report-details/filters-modal-v2/FiltersModal.vue'
import SaveReportModal from '@/views/admin/reports-v2/reports/report-details/save-report-modal/SaveReportModal.vue'
import BulkAddToGroupModal from '@/views/components/bulk-add-to-group/BulkAddToGroupModal.vue'
import BulkCommunicateModal from '@/views/components/bulk-communicate-modal/BulkCommunicateModal.vue'
import BulkAddingChargeModal from '@/views/components/adding-charge-modal/BulkAddingChargeModal.vue'
import BulkGenerateLetterModal from '@/views/components/bulk-generate-letter/BulkGenerateLetterModal.vue'
import BulkTagAssignModal from '@/views/components/bulk-tag-assign/BulkTagAssignModal.vue'
import BulkChangeApplicationsStatus from '@/views/components/bulk-change-applications-status/BulkChangeApplicationsStatus.vue'
import { permissionSubjects } from '@/libs/acl/constants'

import dynamicSort from '@/helpers/sortBy'
import ReportDetailsManageButtons
  from '@/views/admin/reports-v2/reports/report-details/components/ReportDetailsManageButtons.vue'

const getDefaultFilters = () => ({
  children: [],
  logicalOperator: 'and',
})
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BPagination,
    BButton,
    BBadge,
    BSpinner,
    BFormCheckbox,
    BTableSimple,
    BTbody,
    BTr,
    BTh,
    BTd,
    BDropdown,
    BDropdownItem,

    vSelect,
    draggable,

    FiltersModal,
    ReportViewListModal,
    SaveReportModal,
    BulkCommunicateModal,
    BulkAddToGroupModal,
    BulkAddingChargeModal,
    BulkGenerateLetterModal,
    BulkTagAssignModal,
    BulkChangeApplicationsStatus,
    ReportDetailsManageButtons,
  },
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
  },
  filters: {
    cutString(val) {
      let string = val
      if (val) {
        if (string.length > 38) {
          string = `${string.slice(0, 35)} ...`
        }
      }
      return string
    },
    fixTableHeaderView(val) {
      val.split()
      return val.split('.').join(': ').replace(/_/g, ' ')
    },
  },
  mixins: [downloadExportFile],
  data() {
    return {
      perPage: 25,
      totalItems: 0,
      currentPage: 1,
      perPageOptions: [10, 25, 50, 100],
      sortBy: null,
      isSortDirDesc: true,
      reportId: this.$router.currentRoute.query?.id,
      reportName: '',
      reportView: null,
      reportViewFields: [],
      selectedFields: [],
      dataSourceList: [],
      fieldsOptions: [],
      filterSelected: null,
      filters: getDefaultFilters(),
      isBusy: false,
      isLoading: false,
      isTableUpdateAllowed: false,
      markedElements: [],
      allElementsChecked: false,
      selectedAllOnThePage: false,
      tableColumns: [],
      showPerPage: false,
      saveReportType: null,
      groupBy: '',
      groupByOptions: [],
      groupedData: [],
      groupElementsChecked: null,
      validationErrors: [],
      permissionSubjects,
    }
  },
  setup() {
    const {
      fetchFields,
      reportExecute,
      reportExport,
      fetchReport,
      postReport,
      updateReport,
    } = useReportDetails()

    return {
      fetchFields,
      reportExecute,
      reportExport,
      fetchReport,
      postReport,
      updateReport,
    }
  },
  computed: {
    programId() {
      return store.getters['verticalMenu/getDefaultProgram']
    },
    dataMeta() {
      const localItemsCount = this.$refs.reportTable ? this.$refs.reportTable.localItems.length : 0
      return {
        from: this.perPage * (this.currentPage - 1) + (localItemsCount ? 1 : 0),
        to: this.perPage * (this.currentPage - 1) + localItemsCount,
        of: this.totalItems,
      }
    },
    executeRequestData() {
      const data = []

      if (this.groupBy) {
        const groupByField = this.groupBy.replace(/`/g, '')
        const reportField = this.reportViewFields.find(el => el.value === groupByField)

        if (reportField) {
          data.push(reportField)
        }
      }

      this.selectedFields.forEach(field => {
        data.push(field)
      })

      return {
        report_view_id: this.reportView.id,
        selected_fields: data.length ? data.map(field => field.value) : [],
        fields_options: data,
        filters: this.filters,
        program_id: this.programId,
      }
    },
    canUpdateReport() {
      return this.$can('update', permissionSubjects.Report)
    },
    canExportCSV() {
      return this.$can('export', permissionSubjects.ExportCSV)
    },
    canSendBulkEmailCommunication() {
      return this.$can('send', permissionSubjects.BulkEmailCommunication)
    },
    canSendBulkSmsCommunication() {
      return this.$can('send', permissionSubjects.BulkSMSCommunication)
    },
    canSendBulkCommunication() {
      return this.canSendBulkEmailCommunication || this.canSendBulkSmsCommunication
    },
  },
  watch: {
    dataMeta() {
      this.handleElementsPerPage()
    },
    perPage() {
      this.resetAllTableData()
    },
    currentPage() {
      this.updateTable()
    },
    selectedFields() {
      if (this.groupBy) {
        const groupByField = this.groupBy.replace(/`/g, '')
        const groupByFieldindex = this.selectedFields.findIndex(item => item.value === groupByField)
        if (groupByFieldindex !== -1) {
          this.groupBy = ''
        }
      }
    },
    groupBy(val) {
      if (val) {
        const field = val.replace(/`/g, '')
        const index = this.selectedFields.findIndex(item => item.value === field)
        if (index !== -1) {
          this.selectedFields.splice(index, 1)
        }
      }
    },
    markedElements(newVal, prevVal) {
      if (newVal.length < prevVal.length) {
        this.allElementsChecked = false
        this.selectedAllOnThePage = false
      }
      this.checkIfAllElementsAreSelectedOnThePage()
    },
    async programId(val) {
      if (val && this.reportView) {
        await this.updateAllReportData(this.reportView)
        this.selectedFields = []
        this.totalItems = 0
        this.isTableUpdateAllowed = false
        this.$refs.reportTable.refresh()
      }
    },
  },
  async created() {
    if (this.reportId) {
      this.isLoading = true
      await this.fetchReport(this.reportId)
        .then(response => {
          this.reportName = response.name
          this.reportView = response.reportView
          this.filters = response.filters
          this.groupBy = response.group_by

          this.setReportViewFields(response.reportView)
            .then(() => {
              this.setSelectedFields(response.selected_fields)
            })
            .then(() => {
              this.updateTable()
            })
        })
        .finally(() => {
          this.isLoading = false
        })
    } else {
      this.reportName = 'New Report'
    }
  },
  mounted() {
    if (!this.reportId) {
      this.openReportViewModal()
    }
  },
  methods: {
    checkIfSlotValueIsBase64File(item) {
      if (item) {
        const matches = item.toString().match(/^data:image\/(\w+);base64,/)
        if (!matches) {
          return false
        }
        return matches.length > 0
      }
      return false
    },
    showFilterModal() {
      this.$bvModal.show('filters-modal')
    },
    openReportViewModal() {
      this.$bvModal.show('report-view-list-modal')
    },
    setReportView(val) {
      this.$bvModal.hide('report-view-list-modal')
      this.reportView = val
      this.updateAllReportData(val)
    },
    async updateAllReportData(reportView) {
      this.resetReportViewFields()
      this.resetFilters()

      await this.setReportViewFields(reportView)
    },
    async setReportViewFields(reportView) {
      const data = {
        id: reportView.id,
      }
      if (reportView.with_program_filter) {
        data.params = {
          program_id: this.programId,
        }
      }
      await this.fetchFields(data).then(res => {
        const result = res.fields
        this.reportViewFields = result

        this.fieldsOptions = result.map(field => ({ value: `\`${field.value}\``, text: `${field.label}` }))
      })

      if (this.$route.query.report_program_id) {
        this.selectAll()
        await this.updateTable()
      }
    },
    selectAll() {
      this.selectedFields = [...this.reportViewFields]
    },
    deselectAll() {
      this.selectedFields = []
    },
    removeFieldFromSelected(index) {
      this.selectedFields.splice(index, 1)
    },
    async selectAllFields() {
      this.reportViewFields.forEach(item => {
        // eslint-disable-next-line no-param-reassign
        item.selectedFields = item.fields
      })
    },
    setSelectedFields(selectedFields) {
      const fields = []
      selectedFields.forEach(item => {
        const field = this.reportViewFields.find(el => el.value === item)
        if (field) {
          fields.push(field)
        }
      })
      this.selectedFields = [...fields]
    },
    resetReportViewFields() {
      this.reportViewFields = []
    },
    resetAllTableData() {
      this.updateTable()
      this.markedElements = []
      this.allElementsChecked = false
      this.selectedAllOnThePage = false
    },
    async updateTable() {
      this.isTableUpdateAllowed = true
      this.$refs.reportTable.refresh()
    },
    resetFilters() {
      this.filters = getDefaultFilters()
    },
    removeFilterRow(index) {
      this.filters.children.splice(index, 1)
    },
    removeFilterFromTable(index) {
      this.removeFilterRow(index)
      this.updateTable()
    },
    async fetchTableList() {
      if (this.selectedFields.length === 0 && !this.isTableUpdateAllowed) return []
      this.isBusy = true
      this.groupedData = []
      this.validationErrors = []
      try {
        const queryParams = {
          per_page: this.perPage,
          page: this.currentPage,
          report_view_id: this.reportView.id,
          selected_fields: this.selectedFields.map(field => field.value),
          filters: this.filters,
        }

        if (this.sortBy) {
          queryParams.order_column = `\`${this.sortBy}\``
          queryParams.order_column_dir = this.isSortDirDesc ? 'desc' : 'asc'
        }

        if (this.groupBy) {
          queryParams.group_by = this.groupBy
        }

        if (this.reportView.with_program_filter) {
          queryParams.program_id = this.programId
        }

        const response = await this.reportExecute(queryParams)

        if (response.status === 422) {
          const validationErrors = Object.values(response.data.errors)
          this.validationErrors = validationErrors.flat()
          return []
        }

        this.totalItems = response.data.total
        this.showPerPage = this.totalItems > 0

        let items = []
        if (this.totalItems > 0 && response.data?.data[0]) {
          // eslint-disable-next-line no-underscore-dangle
          if (response.data?.data[0]?.group_by) {
            this.groupByOptions = response.data.data[0].group_by

            this.groupedData = response.data.data.map(item => {
              const grouped = item.group.map(el => ({
                selected: false,
                ...el,
                [this.groupByOptions.name]: this.groupByOptions.value,
                uuid: uuidv4(),
              }))
              return {
                ...item,
                grouped,
                selectAll: false,
                collapsed: true,
              }
            })

            const columns = []
            Object.keys(this.groupedData[0].grouped[0]).forEach(key => {
              if (key !== this.groupByOptions.name) {
                columns.push(key)
              }
            })
            this.tableColumns = columns
            this.tableColumns.unshift(this.groupByOptions.name) // add grouped by col
            items = response.data.data
          } else {
            this.tableColumns = Object.keys(response.data.data[0])
            items = response.data.data.map(item => ({
              selected: false,
              ...item,
            }))
          }
        }
        return items
      } catch (error) {
        return []
      } finally {
        this.isBusy = false
      }
    },
    async exportReport() {
      const queryParams = {
        report_view_id: this.reportView.id,
        selected_fields: this.selectedFields.map(field => field.value),
        filters: this.filters,
      }

      if (this.sortBy) {
        queryParams.order_column = `\`${this.sortBy}\``
        queryParams.order_column_dir = this.isSortDirDesc ? 'desc' : 'asc'
      }

      if (this.reportView.with_program_filter) {
        queryParams.program_id = this.programId
      }

      await this.reportExport(queryParams).then(response => {
        const filename = `${this.reportView.name}-export`
        this.downloadFile(response.data, filename.replace(/\s/g, '-'), 'csv')
      })
    },
    openSaveReportModal(isSaveAs) {
      this.saveReportType = isSaveAs ? 'saveAs' : 'save'
      this.$bvModal.show('save-report-modal')
    },
    async saveReport(name) {
      const queryParams = {
        name,
        report_view_id: this.reportView.id,
        selected_fields: this.selectedFields.map(field => field.value),
        filters: this.filters,
        group_by: this.groupBy,
      }

      if (this.saveReportType === 'saveAs') {
        await this.postReport(queryParams)
        this.$bvModal.hide('save-report-modal')
        return
      }

      if (this.reportId) {
        await this.updateReport(this.reportId, queryParams)
        this.$bvModal.hide('save-report-modal')
      } else {
        await this.postReport(queryParams).then(res => {
          this.$bvModal.hide('save-report-modal')
          this.$router.push({ name: 'admin-report-details', query: { id: res.id } })
        })
      }
    },
    async bulkCommunicateSuccess() {
      this.markedElements = []
      this.allElementsChecked = false
      this.selectedAllOnThePage = false
      this.deselectAllInGrouped()
      this.$bvModal.hide('bulk-communication-modal')
    },
    async bulkAddToGroupSuccess() {
      this.markedElements = []
      this.allElementsChecked = false
      this.selectedAllOnThePage = false
      this.deselectAllInGrouped()
      this.$bvModal.hide('bulk-add-to-group-modal')
    },
    async bulkCreateChargeSuccess() {
      this.markedElements = []
      this.allElementsChecked = false
      this.selectedAllOnThePage = false
      this.deselectAllInGrouped()
      this.$bvModal.hide('bulk-adding-charge-modal')
    },
    async bulkGenerateLetterSuccess() {
      this.markedElements = []
      this.allElementsChecked = false
      this.selectedAllOnThePage = false
      this.deselectAllInGrouped()
      this.$bvModal.hide('bulk-generate-letter-modal')
    },
    async bulkTagAssignSuccess() {
      this.markedElements = []
      this.allElementsChecked = false
      this.selectedAllOnThePage = false
      this.deselectAllInGrouped()
      this.$bvModal.hide('bulk-tag-assign-modal')
    },
    async bulkChangeApplicationsStatusSuccess() {
      this.markedElements = []
      this.allElementsChecked = false
      this.selectedAllOnThePage = false
      this.deselectAllInGrouped()
      this.$bvModal.hide('bulk-change-applications-status-modal')
    },
    markElementsOnGroup(index, val) {
      const groupRows = this.groupedData[index].grouped
      if (val) {
        groupRows.forEach(row => {
          const rowIndex = this.markedElements.indexOf(row)
          if (rowIndex < 0) {
            this.markedElements.push(row)
          }
        })
      } else {
        groupRows.forEach(row => {
          const rowIndex = this.markedElements.indexOf(row)
          if (rowIndex >= 0) {
            this.markedElements.splice(rowIndex, 1)
          }
        })
      }
    },
    selectAllOnTheReport(val) {
      if (val) {
        this.markElementsOnPage(val)
      } else {
        this.markedElements = []
      }
    },
    markElementsOnPage(val) {
      if (this.groupedData.length) {
        this.markGroupedElementsOnPage(val)
      } else {
        this.markElementsOnPageWithoutGrouping(val)
      }
    },
    markGroupedElementsOnPage(val) {
      this.groupedData.forEach((group, index) => {
        this.markElementsOnGroup(index, val)
      })
    },
    markElementsOnPageWithoutGrouping(val) {
      if (val) {
        this.$refs.reportTable.localItems.forEach(el => {
          const index = this.markedElements.indexOf(el)
          if (index < 0) {
            this.markedElements.push(el)
          }
        })
      } else {
        this.$refs.reportTable.localItems.forEach(el => {
          const index = this.markedElements.indexOf(el)
          if (index >= 0) {
            this.markedElements.splice(index, 1)
          }
        })
      }
    },
    handleElementsPerPage() {
      if (this.allElementsChecked) {
        this.markElementsOnPage(true)
      }
      this.checkIfAllElementsAreSelectedOnThePage()
    },
    sortByColumn(column) {
      this.sortBy = column
      this.isSortDirDesc = !this.isSortDirDesc
      this.updateTable()
    },
    sortForGroupedData(column) {
      this.sortBy = column
      this.isSortDirDesc = !this.isSortDirDesc
      this.groupedData.forEach(el => {
        const sorted = el.grouped.sort(dynamicSort(this.sortBy, this.isSortDirDesc))
        // eslint-disable-next-line no-param-reassign
        el.grouped = sorted
      })
    },
    getHeaderHeight(refName) {
      if (this.$refs[refName] !== undefined && this.$refs[refName].length > 0) {
        return `${this.$refs[refName][0].clientHeight}px`
      }
      return '60px'
    },
    getContainerWith() {
      if (this.$refs.groupedTablesContainer !== undefined) {
        return `${this.$refs.groupedTablesContainer.scrollWidth}px`
      }
      return '100%'
    },
    toggleGroupedTableCollapse(index) {
      this.groupedData[index].collapsed = !this.groupedData[index].collapsed
    },
    collapseAll() {
      this.groupedData.forEach(item => {
        // eslint-disable-next-line no-param-reassign
        item.collapsed = true
      })
    },
    expandAll() {
      this.groupedData.forEach(item => {
        // eslint-disable-next-line no-param-reassign
        item.collapsed = false
      })
    },
    deselectAllInGrouped() {
      if (this.groupedData.length) {
        this.groupedData.forEach(item => {
          // eslint-disable-next-line no-param-reassign
          item.selectAll = false
        })
      }
    },
    checkIfAllElementsAreSelectedOnThePage() {
      if (this.groupedData.length) {
        const markedElements = this.markedElements.map(item => JSON.stringify(item))
        const allGroupedItems = []
        this.groupedData.forEach(el => {
          const groupedItems = el.grouped.map(row => JSON.stringify(row))
          const isAllSelectedOnGroup = groupedItems.every(v => markedElements.includes(v))
          // eslint-disable-next-line no-param-reassign
          el.selectAll = isAllSelectedOnGroup

          allGroupedItems.push(...groupedItems)
        })
        const isAllSelectedOnThePage = allGroupedItems.every(v => markedElements.includes(v))
        this.selectedAllOnThePage = isAllSelectedOnThePage
      } else {
        const localItems = this.$refs.reportTable.localItems.map(item => JSON.stringify(item))
        const markedElements = this.markedElements.map(item => JSON.stringify(item))
        const isAllSelectedOnThePage = localItems.every(v => markedElements.includes(v))
        this.selectedAllOnThePage = isAllSelectedOnThePage
      }
    },
    saveFilters(filters) {
      this.filters = filters
      this.updateTable()
    },
  },
}
</script>

<style lang="scss" scoped>
  .overflow {
    overflow-x: scroll;
  }
  .table-header {

    label {
      margin-bottom: 0;
    }
  }
  .per-page-selector {
    width: 90px;
  }
  .break-word{
    word-break: break-all;
  }
  .image-slot {
    max-height: 5vh;
  }
  .stiky-rowspan {
    position: sticky;
    top: 60px;
    z-index: 3;
    &__value {
      font-weight: 400;
    }
    &__total {
      font-weight: 600;
    }
    &__collapse {
      position: absolute;
      right: -10px;
      top: 10px;
    }
  }
  .badge-selected-column {
    padding: 5px;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    span {
      margin-left: 5px;
    }
    .close-icon {
      position: absolute;
      top: calc(50% - 6px);
      right: 5px;
    }
  }
  .grouped-tables-container {
    overflow-x: auto;
  }
</style>
